export default __webpack_public_path__ + "static/browse-1dc2900b16d5c4fc860ba8e9c05ee22f.png";